import { get, omit, merge } from 'lodash-es'
import { windowOpenSelf, windowLocationReplace } from './url-handler'
import { formPost } from './form-emulator'
import { NATIVE_CALLBACK } from '../lib/const'
import { callNative } from './sys-kit'
import { setQS, getQS, setEvokePolicy } from './storage-provider'
import { wxJsApiPay } from './wx-jsapi'
import { IPaymentChannelHandler } from '../types'
import { PAYMENT_WITH_SDK } from '../lib/const'
import to from 'await-to-js'
import { types } from './store'

export async function paymentChannelHandler({
  ctx,
  applyPay,
  payToken,
  payChannelID,
  vueCtx,
}: IPaymentChannelHandler) {
  let res, err, evokeType, evokePolicy
  if (!PAYMENT_WITH_SDK.includes(payChannelID)) {
    ;[err, res] = await to(applyPay({ payToken, pay_channel_id: payChannelID }))
    if (err) {
      return console.log(err)
    }
    evokeType = get(res, 'evokeType')
    evokePolicy = get(res, 'evokePolicy')
    vueCtx.$store.commit(types.SET_PAYMENT_CHANNEL_INFO, res)
    setEvokePolicy(evokePolicy)
  }
  const paytmActionUrl: string = get(res, 'payInfo.WAP_GATEWAY_URL', '')
  const adyenActionUrl: string = get(res, 'payInfo.post_url', '')
  const toCtoPActionUrl: string = get(res, 'payInfo.post_url', '')
  const globalAlipayUrl: string = get(res, 'payInfo.redirectActionForm.redirectUrl', '')
  switch (payChannelID) {
    // 支付宝h5
    case 110:
    case 112:
      windowLocationReplace(get(res, 'html'))
      break
    // 支付宝native
    case 113:
      callNative({
        action: 'aliPay',
        content: {
          orderString: get(res, 'html'),
        },
        callback: NATIVE_CALLBACK,
      })
      break
    // 微信jsapi
    case 201:
    case 214:
      wxJsApiPay({
        config: {
          appId: get(res, 'app_id'),
          timeStamp: get(res, 'time_stamp'),
          nonceStr: get(res, 'nonce_str'),
          package: get(res, 'package'),
          signType: get(res, 'sign_type'),
          paySign: get(res, 'pay_sign'),
        },
        callBack: ctx.goToComponent,
      })
      break
    // 微信native
    case 203:
      callNative({
        action: 'wxPay',
        content: {
          prepayId: get(res, 'prepay_id'),
          nonceStr: get(res, 'nonce_str'),
          timeStamp: get(res, 'time_stamp'),
          package: get(res, 'package'),
          sign: get(res, 'sign'),
        },
        callback: NATIVE_CALLBACK,
      })
      break
    // 微信h5
    case 205:
      ctx.goToComponent({ component: 'Result', type: 'question' })
      setQS(merge(getQS(), { payChannel: 205 }))
      windowOpenSelf(get(res, 'mweb_url'))
      break
    // adyen
    case 902:
    case 903:
      ctx.loadingBeforeJump()
      formPost(adyenActionUrl, omit(get(res, 'payInfo', {}), ['post_url']))
      break
    // paytm
    case 1002:
      ctx.loadingBeforeJump()
      formPost(paytmActionUrl, omit(get(res, 'payInfo', {}), ['WAP_GATEWAY_URL']))
      break
    case 1100:
      ctx.loadingBeforeJump()
      formPost(toCtoPActionUrl, omit(get(res, 'payInfo', {}), ['post_url']))
      break
    case 1200:
    case 1201:
    case 1300:
    case 1301:
      ctx.loadingBeforeJump()
      windowLocationReplace(globalAlipayUrl)
      break
    case 202:
    case 104:
      ctx.goToComponent({ component: 'QRCode' })
      break
    case 301:
    case 501:
    case 1401:
      return Promise.resolve({ evokeType, evokePolicy })
    default:
      ctx.showToast({ message: 'unknownPaymentMethod', type: 'warning' })
  }
}
